<template>
    <div class="dispatch-dialog-container">
        <el-dialog title="设备选择" :visible.sync="show"
                   @close="addCloseHandler"  width="650px">
            <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange"
                      ref="multipleTable" v-loading="listLoading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="equipmentId" label="设备编号"></el-table-column>
                <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
                <el-table-column prop="status" label="设备状态">
                    <template slot-scope="scope">
                        {{scope.row.status | dicFilter('EQUIP_STATUS')}}
                    </template>
                </el-table-column>

            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <template  v-if="typeArr.includes(dispatchType)">
                  <el-button type="primary" @click="addConfirm1(0)">全量同步</el-button>
                  <el-button type="primary" @click="addConfirm1(1)">增量同步</el-button>
                </template >
                <el-button v-else type="primary" @click="addConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getEquipmentList,dispatch,dispatch1 } from '../../api/equipment'
    import localCache from "../../util/localCache";
    export default {
        name: "DispatchDialog",
        props:{
            dispatchType: {
                type: Number,
                default: 0
            },
            equipmentType: {
              type: Number,
              default: 0
            },
            selectDataIds: {
              type: String,
              default: ''
            }
        },
        data() {
            return {
                listLoading: true,
                tableData: [],
                show:false,
                selectRow: '',
                staffIds:'',
                typeArr: [3,4,5]
            }
        },
        mounted(){

        },
        methods:{
            open(param = {}){
                this.staffIds = param.staffIds
                this.show = true
                this.getList()
            },
            handleSelectionChange(val){
                this.selectRow = val
                console.log(val)
            },
            addCloseHandler(){
                this.$refs.multipleTable.clearSelection();
            },
            addConfirm() {
                if(!this.selectRow){
                    this.$message.error('请选择设备')
                    return
                }
                let equipmentIds = this.selectRow.map(t=>t.equipmentId).join(',')
                dispatch({
                    customerId: localCache.getCurrentCustomerId(),
                    equipmentIds: equipmentIds,
                    type: this.dispatchType,
                    staffIds: this.staffIds
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.$message.success(res.message)
                        this.show = false
                    }
                }).catch((e) => {
                })
            },
          addConfirm1(type) {
            console.log(this.dispatchType,type, this.selectDataIds)
            if(!this.selectRow){
              this.$message.error('请选择设备')
              return
            }
            let equipmentIds = this.selectRow.map(t=>t.equipmentId).join(',')
            let dataIds = this.selectDataIds

            dispatch1({
              customerId: localCache.getCurrentCustomerId(),
              equipmentIds: equipmentIds,
              dataIds: dataIds,
              type: this.dispatchType,
              allFlag: type
            }).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.$message.success(res.message)
                this.show = false
              }
            }).catch((e) => {
            })
          },
            getList() {
                getEquipmentList({
                    customerId: localCache.getCurrentCustomerId(),
                    equipmentType: this.equipmentType
                }).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.tableData = res.data
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
        }
    }
</script>

<style scoped>

</style>
